export const CITIES = [
  {
    id: "helsinki",
    name: "Helsinki",
    tagline: "Capital · Design district · Saunas by the sea",
    region: "Uusimaa",
    population: "658k",
    founded: 1550,
    lat: 60.1699,
    lng: 24.9384,
    accent: "var(--royal)",
  },
  {
    id: "turku",
    name: "Turku",
    tagline: "Oldest city · Archipelago gateway · River culture",
    region: "Southwest Finland",
    population: "201k",
    founded: 1229,
    lat: 60.4518,
    lng: 22.2666,
    accent: "var(--teal)",
  },
  {
    id: "tampere",
    name: "Tampere",
    tagline: "Sauna capital · Lakeside · Industrial soul",
    region: "Pirkanmaa",
    population: "256k",
    founded: 1779,
    lat: 61.4978,
    lng: 23.7610,
    accent: "var(--lavender)",
  },
  {
    id: "hanko",
    name: "Hanko",
    tagline: "Seaside villas · Southernmost town · Summer regatta",
    region: "Uusimaa",
    population: "8k",
    founded: 1874,
    lat: 59.8230,
    lng: 22.9669,
    accent: "var(--royal)",
  },
  {
    id: "porvoo",
    name: "Porvoo",
    tagline: "Old town · Red shore houses · Riverside cafes",
    region: "Uusimaa",
    population: "51k",
    founded: 1346,
    lat: 60.3953,
    lng: 25.6651,
    accent: "var(--teal)",
  },
] as const;

export type CityId = (typeof CITIES)[number]["id"];
